import { ChangeDetectionStrategy, Component } from '@angular/core';

import { FaqWidgetService } from '../../services/faq-widget.service';

@Component({
  selector: 'app-faq-menu-link',
  templateUrl: './faq-menu-link.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class FaqMenuLinkComponent {
  constructor(private readonly faqWidgetService: FaqWidgetService) {}

  protected openWidget(): void {
    this.faqWidgetService.open();
  }
}
